module.exports = __webpack_public_path__ + "static/media/powerBankPhoto.f100e089.jpg";